// export const adminUrl = "https://jouzour.newages-leb.com/api"
// export const uploadUrl = "https://JCMS.newages-leb.com/api/"

export const adminUrl = 'https://test.adoptacedar.org/api/';
export const uploadUrl = 'https://admin.adoptacedar.org/api/';
